module.exports = __webpack_public_path__ + "static/WelcomeToElk4-f8ff9156cff83fbff72a814c42e35b79.png";